import styles from '../../../styles.module.scss';

type Props = {
  payload?: { value: string };
  x?: string | number;
  y?: string | number;
  textAnchor?: string;
};

export const CustomTick: React.FC<Props> = ({ payload, x, y, textAnchor }) => {
  if (!payload) return null;

  const text = payload.value;
  // 改行文字で分割
  const lines = text.split('\n');

  return (
    <text x={x} y={y} textAnchor={textAnchor} className={styles.radarLabel}>
      {lines.map((line: string, index: number) => (
        <tspan key={index} x={x} dy={index === 0 ? 0 : 12}>
          {line}
        </tspan>
      ))}
    </text>
  );
};
